const en = {
  titles: {
    contactUs: 'Contacting us',
    addQuestion: 'Adding your question',
  },
};

export default en;
